/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Offline_UnavailableInputs */

const en_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline voices are not available in this browser.`)
};

const fr_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les voix hors ligne ne sont pas disponibles dans ce navigateur.`)
};

const de_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Sprachfunktionen sind in diesem Browser nicht verfügbar.`)
};

const it_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le voci offline non sono disponibili in questo browser.`)
};

const ru_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этом браузере функция голосового сопровождения в автономном режиме недоступна.`)
};

const es_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las voces sin conexión no están disponibles en este navegador.`)
};

const zh_cn2_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此浏览器不支持离线语音功能。`)
};

const ja_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザではオフライン音声は利用できません。`)
};

const hi_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ब्राउज़र में ऑफ़लाइन आवाज़ें उपलब्ध नहीं हैं।`)
};

const pt_pt2_voice_manager_offline_unavailable = /** @type {(inputs: Voice_Manager_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vozes offline não estão disponíveis neste navegador.`)
};

/**
* | output |
* | --- |
* | "Offline voices are not available in this browser." |
*
* @param {Voice_Manager_Offline_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_offline_unavailable = /** @type {((inputs?: Voice_Manager_Offline_UnavailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Offline_UnavailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_offline_unavailable(inputs)
	if (locale === "de") return de_voice_manager_offline_unavailable(inputs)
	if (locale === "it") return it_voice_manager_offline_unavailable(inputs)
	if (locale === "ru") return ru_voice_manager_offline_unavailable(inputs)
	if (locale === "es") return es_voice_manager_offline_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_offline_unavailable(inputs)
	if (locale === "ja") return ja_voice_manager_offline_unavailable(inputs)
	if (locale === "hi") return hi_voice_manager_offline_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_offline_unavailable(inputs)
	return en_voice_manager_offline_unavailable(inputs)
});